import React from 'react'
import styled from 'styled-components'
import { Paper } from '@olxbr/design-system'
import PropTypes from 'prop-types'

import medias from '../../../util/medias'
import EmailChangeActivationTemplate from '../../templates/EmailChangeActivationTemplate'

const ContentWrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  padding: 32px 64px;
  ${medias.small`
    margin: 0;
  `}
`

export const EmailChangeActivationPage = ({
  confirmationToken,
  newEmail,
  onRetryChange,
  onSuccess,
  token,
}) => (
  <ContentWrapper>
    <EmailChangeActivationTemplate
      confirmationToken={confirmationToken}
      newEmail={newEmail}
      onRetryChange={onRetryChange}
      onSuccess={onSuccess}
      token={token}
    />
  </ContentWrapper>
)

EmailChangeActivationPage.propTypes = {
  newEmail: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onRetryChange: PropTypes.func.isRequired,
  confirmationToken: PropTypes.string.isRequired,
}
